<template>
  <div class="fade-in">
    <Camera
      headerText="Tire a foto do verso do seu documento"
      onBackGoTo="onboarding-backdoc-step"
      @sendImg="handleImg"
    />
  </div>
</template>

<script>
import Camera from '../components/Camera.vue';

export default {
  name: 'onboarding-backdoc-camera',
  components: { Camera },
  data: () => ({
    cameraOn: false,
    isSelfie: null,
  }),
  methods: {
    async handleImg(img) {
      this.$emit('sendImage', { img, step: 'backdoc' });
    },
  },
};
</script>
